import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthSocialLink, NB_AUTH_OPTIONS, getDeepFromObject } from '@nebular/auth';
import { first } from 'rxjs/operators';
import { OrganizationData } from '../../../@core/data/organization.data';
import { AccountService } from '../../../@core/services/account.service';

@Component({
  selector: 'nb-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  loading = false;
  socialLinks: NbAuthSocialLink[] = [];
  rememberMe = false;

  constructor(
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected router: Router,
    private service: AccountService,
    private orgService: OrganizationData
  ) {
    this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
    this.showMessages = this.getConfigValue('forms.login.showMessages');
    this.strategy = this.getConfigValue('forms.login.strategy');
    this.socialLinks = this.getConfigValue('forms.login.socialLinks');
    this.rememberMe = this.getConfigValue('forms.login.rememberMe');
  }

  login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    this.loading = true;

    this.service
      .authenticate(this.user.email, this.user.password)
      .pipe(first())
      .subscribe({
        next: () => {
          setTimeout(() => {
            this.loading = false;
            this.orgService.getSelectedId()
              .subscribe((result: string) => {
                return this.router.navigate(
                  [`o/${result}/dashboard`],
                );
              });
          }, this.redirectDelay);
          this.cd.detectChanges();
          this.submitted = false;
          this.loading = false;
        },
        error: failures => {
          this.submitted = false;
          this.loading = false;
          failures.error.forEach((err: { errorMessage: string; }) => {
            this.errors.push(err.errorMessage);
            this.cd.detectChanges();
          });
        }
      }
      );
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}